import cx from 'classnames';
import React, {useState} from 'react';
import {IUser} from '../../common/types/User';
import {IOrderItems} from '../../common/types/OrderItems';
import styled from 'styled-components';
import {H1, H2, H3} from '../../components/crousal/Headings';
import {OrderItemsEmptyState} from './OrderItemsEmptyState';

const OrderPageBackgroundImage = styled.div`
 background: url('/images/unrankedsmurfs-login/order_bg.png');
 background-size: cover;

@media (min-width: 1024px) {
  background: url('/images/unrankedsmurfs-login/order_bg.png');
  background-size: cover;
  }
`;

interface IProps {
    orderItems: IOrderItems[];
    global: {
        user: IUser;
    };
}

export function Orders({orderItems}: IProps) {
    const [showDetails, setShowDetails] = useState([false]);

    function showOrderDetails(index: number) {
        const array = [...showDetails];
        for (let i = 0; i < orderItems.length; i++) {
            if (index === i) {
                array[i] = !array[i];
            } else {
                array[i] = false;
            }
        }

        setShowDetails(array);
    }

    return (
        <OrderPageBackgroundImage className={cx(orderItems.length === 0 ? 'h-screen' : '')}>
            <div className="h-full flex relative">
                <div className={cx('w-full bg-gray-100', 'pt-100 lg:pt-200')}>
                    <div className="w-4/5 md:w-1/2 xl:w-2/3 mx-auto mt-10">
                        <div className="flex">
                            <H1 className="text-smurfs-gold">|</H1>
                            <H2 className="p-1">Your orders with us</H2>
                        </div>
                        <p className="mt-2 p-4 text-sm mb-4">
                            View all orders that you have made on UnrankedSmurfs. Remember that you should change your
                            login details after each purchase and verify your email address. For this reason the login
                            details stated here will not be correct after you do that. This record is kept for viewing
                            purposes only.
                        </p>
                        {
                            orderItems.length === 0 ?
                                (
                                    <OrderItemsEmptyState/>
                                ) : (
                                    orderItems.map(
                                        (
                                            {
                                                id,
                                                order,
                                                package_details,
                                                account_details,
                                                region,
                                                rank,
                                                price,
                                                created_at,
                                                type
                                            }, index
                                        ) => {
                                            return (
                                                <div>
                                                    <div
                                                        key={index}
                                                        className={cx(
                                                            'h-1/2 p-2 float-left w-full rounded-lg border-2 border-metallic-grey',
                                                            showDetails[index] ? 'bg-15' : '',
                                                        )}
                                                    >
                                                        <div
                                                            className="cursor-pointer"
                                                            onClick={() => showOrderDetails(index)}
                                                        >
                                                            <div className="flex float-left lg:p-2">
                                                                <H3 className="text-smurfs-gold text-sm lg:text-h4">
                                                                    Order No #{index + 1}
                                                                </H3>
                                                                <p className="lg:ml-6 ml-2 text-xs lg:text-md">
                                                                    Purchased Date : {created_at.split('T')[0]}
                                                                </p>
                                                                <p className="ml-6 text-md hidden lg:inline">
                                                                    Type :&nbsp;{type}
                                                                </p>
                                                                <p className="ml-6 text-md hidden lg:inline">
                                                                    Server :&nbsp;{region.name}
                                                                </p>
                                                                <p className="ml-6 text-md hidden lg:inline">
                                                                    Login Name :&nbsp;{account_details ? <kbd>{account_details.summoner_name}</kbd> : (package_details?.title ?? 'None')}
                                                                </p>
                                                            </div>
                                                            <div className="float-right xl:mt-2">
                                                                <i
                                                                    className={cx(
                                                                        'fas',
                                                                        showDetails[index] ? 'fa-caret-up' : 'fa-caret-down',
                                                                    )}
                                                                />
                                                            </div>
                                                        </div>

                                                        {
                                                            showDetails[index] &&
                                                            <div>
                                                                <div className={cx('h-60 mt-10 w-full flex items-center')}>
                                                                    <div
                                                                        className="flex-1 border-t border-almost-black-light"/>
                                                                </div>

                                                                <div className="flex lg:p-2">
                                                                    <p className="ml-6 text-sm inline lg:hidden">
                                                                        Type :&nbsp;{type}
                                                                    </p>
                                                                    <p className="ml-8 text-sm inline lg:hidden">
                                                                        Server :&nbsp;{region.name}
                                                                    </p>
                                                                </div>
                                                                <p className="ml-6 text-xs inline lg:hidden">
                                                                    Login Name :&nbsp;{account_details ? <kbd>{account_details.summoner_name}</kbd> : (package_details?.title ?? 'None')}
                                                                </p>
                                                                <div className="flex lg:p-2">
                                                                    <p className="w-1/3 text-md hidden lg:inline">
                                                                        Login Name :&nbsp;
                                                                        {
                                                                            account_details.summoner_name ? <kbd>{account_details.summoner_name}</kbd> : (package_details?.title ?? 'None')
                                                                        }
                                                                    </p>
                                                                    <p className="w-1/3 text-md hidden lg:inline">
                                                                        {
                                                                            account_details.email ?
                                                                                'Email Name : ' + account_details.email :
                                                                                'Package Name : ' + (package_details?.name ?? 'None')
                                                                        }
                                                                    </p>
                                                                    <p className="w-1/3 text-md hidden lg:inline">
                                                                        {
                                                                            account_details.summoner_name ?
                                                                                'Name of Account : ' + account_details.summoner_name :
                                                                                'Package Capsules : ' + (package_details?.min_capsules ?? 'None')
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="flex mt-2 lg:p-2">
                                                                    <p className="w-1/3 text-md hidden lg:inline">
                                                                        {
                                                                            account_details.password
                                                                                ? <>Login Password : <kbd>{account_details.password}</kbd></>
                                                                                : <>Package Price : {package_details?.price ?? 'None'}</>
                                                                        }
                                                                    </p>
                                                                    <p className="w-1/3 text-md hidden lg:inline">
                                                                        {
                                                                            account_details.email_password
                                                                                ? <>Email Password : <kbd>{account_details.email_password}</kbd></>
                                                                                : <>Package Old Price : {package_details?.price ?? 'None'}</>
                                                                        }
                                                                    </p>
                                                                    <p className="w-1/3 text-md hidden lg:inline">
                                                                        {
                                                                            account_details.blue_essence ?
                                                                                'Blue Essence : ' + account_details.blue_essence :
                                                                                'Blue Essence' + (package_details?.min_blue_essence ?? 'None')
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="flex mt-2 lg:p-2">
                                                                    <p className="w-1/3 text-md hidden lg:inline">
                                                                        {
                                                                            account_details.champions_count ?
                                                                                'Blue Essence : ' + account_details.champions_count :
                                                                                'Champions : ' + (package_details?.min_champions ?? 'None')
                                                                        }
                                                                    </p>
                                                                    <p className="w-1/3 text-md hidden lg:inline">
                                                                        {
                                                                            account_details.skins_count ?
                                                                                'Skins : ' + account_details.skins_count :
                                                                                'Skins : ' + (package_details?.min_skins ?? 'None')
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className={cx('h-60 w-full flex items-center')}>
                                                        <div className="flex-1 border-t border-almost-black-light"/>
                                                    </div>
                                                </div>
                                            );
                                        })
                                )
                        }
                        <div className="flex mt-10">
                            <H1 className="text-smurfs-gold">|</H1>
                            <H2 className="p-1">Important resources</H2>
                        </div>
                        <div className="flex mt-6 text-sm">
                            <img style={{height: '50px'}} src={"/images/unrankedsmurfs-login/login_shield.png"}
                                 alt={"shield image"}/>
                            <p>
                                How to change password, verify email and keep your account safe guide.
                            </p>
                        </div>
                        <div className="flex text-sm">
                            <img style={{height: '50px'}} src={"/images/unrankedsmurfs-login/login_shield.png"}
                                 alt={"shield image"}/>
                            <p>
                                How to copy your settings to your new smurf guide.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </OrderPageBackgroundImage>
    );
}
